export interface BeThemeOptions {
    logo_url_kind: "default" | "url" | "page" | "site_url";
    logo_url: string;
    logo_url_page: string;
    logo_url_target: string;
    smGridWidth: number;
    mdGridWidth: number;
    lgGridWidth: number;
    xlGridWidth: number;
    expand_current_menu_item: boolean;
}

const $ = jQuery;

export class BeTheme {

    constructor() {
        if (!e5.Plugins.config?.betheme) {
            e5.console.warn(`[eventfive.wordpress-plugin]", "[BeTheme]", "BeTheme configuration missing. Maybe update config under "eventfive > BeTheme".`);
            return;
        }

        e5.console.log("[eventfive.wordpress-plugin]", "[BeTheme]");

        this.removeUnnecessaryAriaExpandedFromSideNav();

        //TODO: toggle button aria-expanded
        $('.responsive-menu-toggle').attr('aria-expanded', 'false');

        this.fixDoubleMainLandmark();
        this.nvdaKeySwallowFixMainNav();
        this.localizeSocialBar();
        this.localizeMagnificPopup();
        this.addSkiplinks();
        this.addResponsiveDebugView();
        this.logoUrl();
        this.expandMenuItems();
        this.closeMobileMenuByKeyboard();
    }

    /**
     * Irgendwie komisch das BeTheme das aria-expanded Attribut nicht ändert,
     * wenn das Menü geöffnet wird. Deshalb entfernen wir es hier... Möglicherweise
     * wird es später von BeTheme gefixt, dann muss diese Zeile wieder entfernt werden.
     */
    private removeUnnecessaryAriaExpandedFromSideNav(): void {
        $('#Side_slide').removeAttr('aria-expanded');
    }

    /**
     * BeTheme uses two main landmarks. This is not valid HTML.
     * 
     * In BeTheme's accessibility.js the role is set to "main" for the #Content element.
     * BeTheme does not check if there is already a main element in the DOM!
     */
    private fixDoubleMainLandmark(): void {
        if (document.querySelector("main")
            && document.querySelector(`#Content[role="main"]`)) {
            setTimeout(() => {
                document.querySelector("#Content").removeAttribute("role");
            }, 500);
        }
    }

    /**
     * NVDA (Screenreader) does not fire keydown/keyup it will emulate onClick instead.
     * To prevent NVDA to "swallow" the keyboard event, we need to set the role to application.
     * 
     * If we don't set the role to application, the keyboard event will not be fired and the menu toggle will not work
     * when NVDA is enabled.
     * 
     * @see https://github.com/nvaccess/nvda/issues/7898
     * @see https://github.com/downshift-js/downshift/issues/458
     */
    private nvdaKeySwallowFixMainNav(): void {
        const topBar = document.querySelector("#Top_bar");
        if (topBar) {
            topBar.setAttribute("role", "application");
        }
    }

    /**
     * Localize social bar
     * 
     * TODO: translate by current language
     */
    private localizeSocialBar() {
        $('.social').attr('aria-label', 'Soziale Netzwerke');

        /**
         * Normalerweise steht in im dem aria-label sowas wie "Facebook icon"
         * Wir setzen das aria-label auf den title des Links. Dann steht da z.B. "Facebook" statt "Facebook icon".
         */
        $(".social a").each(function () {
            const $this = $(this);
            const title = $this.attr("title");
            if (title) {
                $this.attr("aria-label", title);
            }
        });
    }

    /**
     * Localize magnific popup which is used by BeTheme for lightbox
     * 
     * TODO: translate by current language
     * 
     * @see https://dimsemenov.com/plugins/magnific-popup/documentation.html#i18n
     */
    private localizeMagnificPopup(): void {
        if ((jQuery as any).magnificPopup) {
            const magnific: any = (jQuery as any).magnificPopup;
            magnific.defaults.tClose = "Fenster Schließen";
            magnific.defaults.closeMarkup = `<button aria-label="Fenster Schließen" type="button" class="mfp-close">&#215;</button>`;
        }
    }

    /**
     * Add skiplinks to the page
     */
    private addSkiplinks(): void {
        const skiplinks: { id: string; label: string }[] = [
            { id: "Content", label: "Zum Inhalt springen" },
            // { id: "menu", label: "Zur Navigation" },
        ];

        const items: string[] = [];
        for (const item of skiplinks) {
            if (!document.getElementById(item.id)) {
                continue;
            }
            items.push(`<li><a href="#${item.id}">${item.label}</a></li>`);
        }

        if (items.length === 0) {
            console.warn("No skiplinks found.");
            return;
        }

        $('body').prepend(`<ul class="e5-be-skiplinks" aria-label="${items.length > 1 ? "Einsprunglinks" : ""}">${items.join("")}</ul>`);
    }

    /**
     * Add responsive debug view
     */
    private addResponsiveDebugView(): void {

        const options = e5.Plugins.config.betheme;

        e5.Debug.add({
            uid: "betheme-responsive",
            tooltip: `BeTheme Breaktpoints:
                <br>SM ${options.smGridWidth}px
                <br>MD ${options.mdGridWidth}px
                <br>LG ${options.lgGridWidth}px
                <br>XL ${options.xlGridWidth}px
            `,
            label: "",
            onInit: (item) => {
                const updateLabel = () => {
                    const w = window.innerWidth;
                    if (w < options.smGridWidth) {
                        item.label = "SM";
                    }
                    else if (w < options.mdGridWidth) {
                        item.label = "MD";
                    }
                    else if (w < options.lgGridWidth) {
                        item.label = "LG";
                    }
                    else {
                        item.label = "XL";
                    }
                };
                window.addEventListener("resize", updateLabel);
                updateLabel();
            }
        });
    }

    /**
     * Close mobile menu on escape
     */
    private closeMobileMenuByKeyboard(): void {
        document.addEventListener("keyup", (e) => {
            if (!e5.KeyCode.is(e, e5.KeyCode.ESCAPE)) {
                return;
            }

            const toggleButton = jQuery("body.side-slide-is-open #Side_slide > div.close-wrapper > a");
            if (toggleButton.length > 0) {
                toggleButton.trigger("click");
            }
        });
    }

    /**
     * Expand current menu items
     */
    private expandMenuItems(): void {
        if (!e5.Plugins.config.betheme.expand_current_menu_item) {
            return;
        }

        document.querySelectorAll("#menu .current-menu-item")
            .forEach(
                (e) => {
                    let p = e.parentElement as HTMLElement;
                    while (p) {
                        if (p.classList.contains("menu-item")) {
                            p.classList.add("hover");
                        }
                        else if (p.classList.contains("sub-menu")) {
                            p.style.display = "block";
                        }
                        p = p.parentElement as HTMLElement;
                    }
                }
            );
    }

    /**
     * Logo URL
     */
    private logoUrl(): void {
        if (e5.Plugins.config.isAdmin) {
            return;
        }

        const options = e5.Plugins.config.betheme;

        let logoUrl: string = "";
        if (options.logo_url_kind === "default") {
            //empty
        }
        else if (options.logo_url_kind === "url") {
            logoUrl = options.logo_url;
        }
        else if (options.logo_url_kind === "page") {
            logoUrl = options.logo_url_page;
        }
        else if (options.logo_url_kind === "site_url") {
            logoUrl = e5.Plugins.config.siteUrl;
        }

        if (logoUrl) {
            const logo = document.querySelector<HTMLAnchorElement>("#logo");
            if (!logo) {
                console.warn("Logo URL konnte nicht angepasst werden, da kein Logo gefunden wurde.");
            } else if (logo.tagName !== "A") {
                console.warn("Logo URL konnte nicht angepasst werden, da das Element kein HTMLAnchorElement ist.");
            } else {
                logo.href = logoUrl;
                logo.target = options.logo_url_target;
            }
        }
    }
}

e5.ready(() => {
    new BeTheme();
});